module.exports = __webpack_public_path__ + "static/media/p1.e8c023ce.jpeg";